/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Wide_Snail_BeamInputs */

const en_green_wide_snail_beam = /** @type {(inputs: Green_Wide_Snail_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created at`)
};

const de_green_wide_snail_beam = /** @type {(inputs: Green_Wide_Snail_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

/**
* | output |
* | --- |
* | "Created at" |
*
* @param {Green_Wide_Snail_BeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_wide_snail_beam = /** @type {((inputs?: Green_Wide_Snail_BeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Wide_Snail_BeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_wide_snail_beam(inputs)
	return de_green_wide_snail_beam(inputs)
});